import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class Urgency extends Data {
	public static className = 'Urgency'
	public static primaryKey = 'RID'
	public static systemFields = [
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	Balance?: number
	Description?: string
	Abbr?: string
	TypeId?: number
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	LanguageDescriptionCalc?: string
}